import { createApp } from 'vue';
import App from './App.vue';
import router from './routes';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

import { IonicVue } from '@ionic/vue';
import { defineCustomElements } from '@ionic/pwa-elements/loader';

import { store, storeTypes } from '@/store/store';

import '@/styles/ionic_variables.css';
import '@/styles/utilities.css';
import Markdown from 'vue3-markdown-it';
import {i18n} from "@/i18n";

const app = createApp(App)
  .use(IonicVue, {
    backButtonText: '',
  })
  .use(router)
  .use(store, storeTypes)
  .use(i18n)
  .use(Markdown);

router.isReady().then(() => {
  app.mount('#app');
});



// Call the element loader after the platform has been bootstrapped
defineCustomElements(window);